/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnInit } from '@angular/core';

import { AppUtilityService } from './../../services/app-utility.service';
import { ConfigService } from '../../services/config.service';
import { SelectItem } from 'primeng/api/selectitem';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { UserConfigService } from './../../services/user-config.service';
import { UserPrefWindow } from './../../model/user-pref-window-model';

/**
 * @export
 * @class LmsUserProfileWindowComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-user-profile-window',
  templateUrl: './lms-user-profile-window.component.html',
  styleUrls: ['./lms-user-profile-window.component.scss']
})
export class LmsUserProfileWindowComponent implements OnInit {

  private userConfigData;
  @Input() userPrefWindow: UserPrefWindow;
  filteredResults: Array<string> = [];
  mileposts: Array<string> = [];
  mnemonics: Array<string> = [];
  commonopsPicklist: any;
  windowNameList: Array<SelectItem> = [];
  selectedWindowName: string;
  terminalMnemonic: string;
  noThroughTrains = false;
  deskList: Array<SelectItem> = [];
  selectedDeskName: string;
  searchTerminalMnemonicError: boolean;
  @Input() tabLevel: number;
  @Input() index: number;

  /**
   * Creates an instance of LmsUserProfileWindowComponent.
   * @param {UserConfigService} userConfigService
   * @param {StaticDataStoreService} staticDataStoreService
   * @memberOf LmsUserProfileWindowComponent
   */
  constructor(private userConfigService: UserConfigService,
    private staticDataStoreService: StaticDataStoreService,
    private configService: ConfigService,
    private appUtilityService: AppUtilityService) {
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
  }

  /**
   * Initialize the state lifecycle hook.
   * @memberOf LmsUserProfileWindowComponent
   */
  ngOnInit() {
    this.userConfigData = this.userConfigService.getUserConfigData();
    this.loadWindowList();
  }

  /**
   * Invoked when click on clear button below window dropdown.
   * @memberOf LmsUserProfileWindowComponent
   */
  clearWindow() {
    this.windowNameList = [];
    if (this.userConfigData && this.userConfigData.userProfile &&
      this.userConfigData.userProfile.windowNameList && this.userConfigData.userProfile.windowNameList.values) {
      this.windowNameList = this.userConfigData.userProfile.windowNameList.values;
    }
    if (this.windowNameList && this.windowNameList.length > 0) {
      this.selectedWindowName = this.windowNameList[0].label;
      this.userPrefWindow.windowName = this.selectedWindowName;
    }
    if (this.userConfigData && this.userConfigData.userProfile && this.userConfigData.userProfile.deskList) {
      for (const deskName of this.userConfigData.userProfile.deskList) {
        this.deskList.push({
          label: deskName,
          value: deskName
        });
      }
      if (this.deskList && this.deskList.length > 0) {
        this.selectedDeskName = this.deskList[0].label;
        this.userPrefWindow.deskName = this.selectedDeskName;
      }
    }
    this.terminalMnemonic = '';
    this.selectedDeskName = '';
    this.noThroughTrains = false;
    this.userPrefWindow.terminalMnemonic = '';
    this.userPrefWindow.deskName = '';
    this.userPrefWindow.isMnemonicError = false;
    setTimeout(() => {
      this.appUtilityService.setFocusToFirstElement('window-pref-' + this.tabLevel);
    }, 20);


  }

  /**
   * Invoked when window selection change.
   * @memberOf LmsUserProfileWindowComponent
   */
  changeWindowName() {
    this.selectedDeskName = '';
    this.terminalMnemonic = '';
    this.userPrefWindow.terminalMnemonic = '';
    this.userPrefWindow.deskName = '';
    this.userPrefWindow.windowName = this.selectedWindowName;
    if ('Outlying-Points Data' === this.selectedWindowName) {
      this.loadDeskList();
    }
    setTimeout(() => {
      if (this.selectedWindowName && (this.selectedWindowName === 'Terminal Status' || this.selectedWindowName === 'Terminal Handling')) {
        this.setFocusToGivenElement('userProfileTerminalMnemonic' + this.index);
      } else if (this.selectedWindowName && this.selectedWindowName === 'Outlying-Points Data') {
        this.setFocusToGivenElement('userProfileOutlyingDesk' + this.index);
      }
    }, 20);
  }

  public setFocusToGivenElement(inputId: string) {
    if (inputId && inputId.length > 0) {
      setTimeout(() => {
        const input = document.getElementById(inputId);
        if (input) {
          input.focus();
        }
      }, 20);
    }
  }

  /**
   * Show terminal and milepost values in terminal autocomplete.
   * @param {any} event
   * @memberOf LmsUserProfileWindowComponent
   */
  autoCompleteForTerminal(event) {
    this.mnemonics = [];
    this.mileposts = [];
    if (this.commonopsPicklist) {
      const data = this.commonopsPicklist.mapOfMnemonis ? this.commonopsPicklist.mapOfMnemonis : null;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.mnemonics.push(data[key]);
          this.mileposts.push(key);
        }
      }
    }
    this.filteredResults = this.mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    Array.prototype.push.apply(this.filteredResults, (this.mileposts.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    })));
    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }

  /**
   * Select value from autocomplete dropdown.
   * @param {string} value
   * @memberOf LmsUserProfileWindowComponent
   */
  selectValueFromAutoComplete(value: string) {
    let emitValue = value;
    if (this.commonopsPicklist) {
      const data = this.commonopsPicklist.mapOfMnemonis ? this.commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    this.userPrefWindow.terminalMnemonic = emitValue;
    this.terminalMnemonic = emitValue;

  }

  /**
   * Load window from user profile config.
   * Make selected windows which are already allpied.
   * @memberOf LmsUserProfileWindowComponent
   */
  loadWindowList() {
    this.windowNameList = [];
    if (this.userConfigData && this.userConfigData.userProfile &&
      this.userConfigData.userProfile.windowNameList && this.userConfigData.userProfile.windowNameList.values) {
      this.windowNameList = this.userConfigData.userProfile.windowNameList.values;
    }

    if (this.userPrefWindow) {
      this.searchTerminalMnemonicError = this.userPrefWindow.isMnemonicError;
      if (this.userPrefWindow.windowName) {
        this.selectedWindowName = this.userPrefWindow.windowName;
        if (this.userPrefWindow.windowName === 'Outlying-Points Data') {
          this.loadDeskList();
        }
      }
      if (this.userPrefWindow.terminalMnemonic) {
        this.terminalMnemonic = this.userPrefWindow.terminalMnemonic;
      }
      if (this.userPrefWindow.noThroughTrains && this.userPrefWindow.noThroughTrains === 'Y') {
        this.noThroughTrains = true;
      } else {
        this.noThroughTrains = false;
      }
    } else {
      if (this.windowNameList && this.windowNameList.length > 0) {
        this.selectedWindowName = this.windowNameList[0].label;
        if (this.userPrefWindow) {
          this.userPrefWindow.windowName = this.selectedWindowName;
        }
      }
    }

  }

  /**
   * Invoked when select/un-select checkbox for no through trains.
   * @param {any} event
   * @memberOf LmsUserProfileWindowComponent
   */
  onChange(event) {
    if (event?.checked) {
      this.userPrefWindow.noThroughTrains = 'Y';
    } else {
      this.userPrefWindow.noThroughTrains = 'N';
    }
    this.searchTerminalMnemonicError = this.userPrefWindow.isMnemonicError;
  }

  /**
   * Invoked for load complete desk list from user profile config.
   * @memberOf LmsUserProfileWindowComponent
   */
  loadDeskList() {
    if (this.commonopsPicklist && this.commonopsPicklist.masterData && this.commonopsPicklist.masterData.zoneList) {
      this.deskList = [];
      for (let i = 0; i < this.commonopsPicklist.masterData.zoneList.length; i++) {
        const zone = this.commonopsPicklist.masterData.zoneList[i];
        this.deskList.push({
          label: zone.zoneCode + ' ' + zone.zoneDescription,
          value: zone.zoneCode
        });
      }
    }

    if (this.userPrefWindow && this.userPrefWindow.deskName) {
      this.selectedDeskName = this.userPrefWindow.deskName;
    } else {
      if (this.deskList && this.deskList.length > 0) {
        this.selectedDeskName = this.deskList[0].value;
        this.userPrefWindow.deskName = this.selectedDeskName;
      }
    }
  }

  /**
   * Invoked when change desk from desk selection window.
   * @memberOf LmsUserProfileWindowComponent
   */
  changeDeskName() {
    this.userPrefWindow.deskName = this.selectedDeskName;
  }
}
